module.exports = __webpack_public_path__ + "7618e71d75cb19f44cafdefcbe5083fb.svg";